export const replaceQueryParamsWith = (urlAsString: string, replace?: string): string => {
    try {
        const url = new URL(urlAsString);
        url.search = replace ?? '';

        return url.toString();
    } catch (error) {
        console.error('Failed to replace URL query params for URL + params', urlAsString, replace, ' Returning the original URL instead.');
        return urlAsString;
    }
};
